/**
 * Script para diagnosticar marcas y proveedores
 */

export const diagnoseBrandsAndSuppliers = async () => {
  try {
    console.log('🔍 === DIAGNÓSTICO DE MARCAS Y PROVEEDORES ===');
    
    // 1. Verificar usuario
    const auth = window.auth.auth;
    const user = auth.currentUser;

    if (!user) {
      console.error('❌ Usuario no autenticado');
      return;
    }
    console.log('✅ Usuario autenticado:', user.uid);

    // 2. Verificar marcas directamente en Firestore
    console.log('\n🏷️ Verificando marcas en Firestore...');
    const { collection, getDocs } = window.auth;
    const brandsRef = collection(window.auth.db, 'users', user.uid, 'brands');
    const brandsSnapshot = await getDocs(brandsRef);
    
    console.log(`📊 Marcas encontradas en Firestore: ${brandsSnapshot.size}`);
    const brandsFromFirestore = brandsSnapshot.docs.map((doc: any) => ({
      id: doc.id,
      ...doc.data()
    }));
    
    if (brandsFromFirestore.length > 0) {
      console.log('📋 Marcas en Firestore:');
      brandsFromFirestore.forEach((brand: any, index: number) => {
        console.log(`  ${index + 1}. ${brand.name} (enabled: ${brand.enabled})`);
      });
    }

    // 3. Verificar proveedores directamente en Firestore
    console.log('\n🏢 Verificando proveedores en Firestore...');
    const suppliersRef = collection(window.auth.db, 'users', user.uid, 'suppliers');
    const suppliersSnapshot = await getDocs(suppliersRef);
    
    console.log(`📊 Proveedores encontrados en Firestore: ${suppliersSnapshot.size}`);
    const suppliersFromFirestore = suppliersSnapshot.docs.map((doc: any) => ({
      id: doc.id,
      ...doc.data()
    }));
    
    if (suppliersFromFirestore.length > 0) {
      console.log('📋 Proveedores en Firestore:');
      suppliersFromFirestore.forEach((supplier: any, index: number) => {
        console.log(`  ${index + 1}. ${supplier.name} (enabled: ${supplier.enabled})`);
      });
    }

    // 4. Probar servicios
    console.log('\n🔧 Probando servicios...');
    let brandsFromService = 0;
    let suppliersFromService = 0;
    
    try {
      const inventoryService = (await import('../services/inventoryService')).default;
      console.log('✅ inventoryService importado');
      
      // Probar getBrands
      console.log('\n🏷️ Probando getBrands...');
      const brands = await inventoryService.getBrands();
      brandsFromService = brands.length;
      console.log(`📦 Marcas desde servicio: ${brands.length}`);
      
      if (brands.length > 0) {
        console.log('📋 Primeras 3 marcas:');
        brands.slice(0, 3).forEach((brand: any, index: number) => {
          console.log(`  ${index + 1}. ${brand.name} (enabled: ${(brand as any).enabled})`);
        });
      }
      
      // Probar getSuppliers
      console.log('\n🏢 Probando getSuppliers...');
      const suppliers = await inventoryService.getSuppliers();
      suppliersFromService = suppliers.length;
      console.log(`📦 Proveedores desde servicio: ${suppliers.length}`);
      
      if (suppliers.length > 0) {
        console.log('📋 Primeros 3 proveedores:');
        suppliers.slice(0, 3).forEach((supplier: any, index: number) => {
          console.log(`  ${index + 1}. ${supplier.name} (enabled: ${(supplier as any).enabled})`);
        });
      }
      
      // Probar funciones FromDocumentedStructure
      console.log('\n🔧 Probando funciones FromDocumentedStructure...');
      
      const brandsFromDoc = await inventoryService.getBrandsFromDocumentedStructure();
      console.log(`📦 Marcas desde getBrandsFromDocumentedStructure: ${brandsFromDoc.length}`);
      
      const suppliersFromDoc = await inventoryService.getSuppliersFromDocumentedStructure();
      console.log(`📦 Proveedores desde getSuppliersFromDocumentedStructure: ${suppliersFromDoc.length}`);
      
    } catch (error) {
      console.error('❌ Error con servicios:', error);
    }

    console.log('\n✅ === DIAGNÓSTICO COMPLETADO ===');
    
    return {
      success: true,
      brandsInFirestore: brandsFromFirestore.length,
      suppliersInFirestore: suppliersFromFirestore.length,
      brandsFromService: brandsFromService,
      suppliersFromService: suppliersFromService,
      user: user.uid
    };

  } catch (error) {
    console.error('❌ Error en diagnóstico:', error);
    return {
      success: false,
      error: error
    };
  }
};

// Hacer disponible en consola
if (typeof window !== 'undefined') {
  (window as any).diagnoseBrandsAndSuppliers = diagnoseBrandsAndSuppliers;
}
